import { useState } from "react";
import Icon from "../../../Icon";
import { IconSize } from "../../../Icon/Icon";
import { TouchableOpacity, StyleSheet } from "react-native";
import RText from "../../../RText";
import { logEvent } from "../../../../client/analytics/trackPageView";

/** This component renders a RaceiQ icon with optional text.
 * They are used in the RaceiQIconBar to display different features.
 *
 * @component
 * @param {Object} props - The properties for the component.
 * @param {RIQIcon} name - The name of the icon to display.
 * @param {IconSize} size - The size of the icon.
 * @param {number} selectedIcon - The index of the currently selected icon
 * @param {function} [setSelectedPrompt - Function to set the selected icon index.
 * @param {number} index - The index of the icon in the list
 * @param {boolean} includeText - Whether to include text below the icon.
 * @param {number} noOfIcons - Total number of icons in the list.
 * @returns {JSX.Element} The rendered icon component.
 *
 */

export type RIQIcon =
  | "draw"
  | "start"
  | "time"
  | "speed"
  | "stride"
  | "finish"
  | "jockey"
  | "jumping";

const RaceiQIcon = ({
  name = "draw",
  size = "medium",
  setSelectedPrompt,
  includeText,
  isSelected = false,
  promptKey,
  fontSize = "xs",
}: {
  name: RIQIcon;
  size: IconSize;
  setSelectedPrompt?: (value: any) => void;
  index?: number;
  includeText?: boolean;
  isSelected?: boolean;
  promptKey?: string;
  fontSize?: "xs" | "sm";
}) => {
  const [iconHovered, setIconHovered] = useState(false);

  return (
    <TouchableOpacity
      onPress={() => {
        !isSelected &&
          logEvent({
            key: "racecard-view-betprompt",
            data: {},
          });
        setIconHovered(false);
        setSelectedPrompt(!isSelected ? promptKey : undefined);
      }}
      style={styles.container}
    >
      <Icon
        name={`${name}${isSelected ? "Selected" : ""}`}
        size={size}
        fill={
          iconHovered && !isSelected
            ? "palette.raceiQ.pinkHover"
            : "palette.rtv.white"
        }
        //@ts-ignore
        onMouseEnter={() => setIconHovered(true)}
        onMouseLeave={() => setIconHovered(false)}
      />
      {includeText ? (
        <RText
          color="secondary"
          weight={isSelected ? "bold" : "regular"}
          size={fontSize}
        >
          {name.capitalize()}
        </RText>
      ) : null}
    </TouchableOpacity>
  );
};

export default RaceiQIcon;

const styles = StyleSheet.create({
  container: {
    marginBottom: 2,
    alignItems: "center",
  },
});
